import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import { Restore as RestoreIcon } from '@mui/icons-material';
import moment from 'moment';

import {
  createStripeInvoiceSession,
  getInvoiceById,
} from '../../../../store/V2/InvoicesSlice/api';
import { useAppSelector } from '../../../../hooks';
import {
  getInvoicesState,
  INVOICE_STATUSES,
  resetInvoiceData,
} from '../../../../store/V2/InvoicesSlice';
import BasicLoader from '../../../../components/Loaders/BasicLoader';

const PayInvoicePage: FunctionComponent = () => {
  const dispatch = useDispatch();
  const params = useParams();

  // Store
  const invoicesState = useAppSelector(getInvoicesState);

  // State
  const [isStripeSessionCreated, setStripeSessionCreated] = useState(false);

  const invoiceId = params.invoiceId || '';
  const invoice = invoicesState.invoiceData;
  const isExpired = Boolean(
    invoice &&
      (moment(invoice.expiryDate) < moment() ||
        invoice.status !== INVOICE_STATUSES.PENDING)
  );

  useEffect(() => {
    if (invoiceId) {
      dispatch(getInvoiceById(invoiceId));
    }

    return () => {
      dispatch(resetInvoiceData());
    };
  }, []);

  useEffect(() => {
    if (invoice && !isExpired && !isStripeSessionCreated) {
      dispatch(createStripeInvoiceSession(invoiceId));

      setStripeSessionCreated(true);
    }
  }, [invoicesState.invoiceData]);

  if (isExpired) {
    return (
      <div>
        <Stack padding="30px" textAlign="center" gap="20px" alignItems="center">
          <RestoreIcon sx={{ fontSize: '80px', color: 'primary.main' }} />
          <Typography variant="h4">This link has expired.</Typography>
          <Typography variant="h6">
            Please contact the support team for help
          </Typography>
        </Stack>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
      }}
    >
      <BasicLoader />
    </div>
  );
};

export default PayInvoicePage;
